export default __webpack_public_path__ + "static/media/10D.956683a1.svg";